import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import BeefreeSDK from '@beefree.io/sdk';
import { selectedOrganizationSelector } from '../../../../redux/selectors/organization';
import { FullScreenContainer } from './BeeFileManager.styled';
import { getBeeToken } from '../../../../redux/services';
import { logout } from '../../../../redux/action';

const BeeFileManager = () => {
  const organizationId = useSelector(selectedOrganizationSelector).id;
  const dispatch = useDispatch();

  const beeEditor = useRef(null);
  const { userHandle, username, userColor } = useSelector(state => ({
    userHandle: state.user.detail._id,
    username: `${state.user.detail.firstName} ${state.user.detail.lastName}`,
    userColor: state.user.detail.avatarColor,
    beeAdmin: state.user.userPrivileges?.beeAdmin,
  }));

  const beeConfig = {
    uid: organizationId,
    userHandle,
    username,
    userColor,
    container: 'bee-plugin-file-manager',
    language: 'en-US',
    trackChanges: true,
    loadingSpinnerDisableOnDialog: true,
    onError: async error => {
      if (error.status_code === 401) {
        // refresh token if it is expired (after 12 hours)
        try {
          const token = await getBeeToken(organizationId);
          beeEditor.current.updateToken(token);
        } catch (refreshError) {
          console.error('Authentication failed:', refreshError);
          dispatch(logout(history));
        }
      } else {
        // log all other errors
        console.error('BEE Editor error:', error);
      }
    },
    onWarning: warning => console.warn('bee editor warning:', warning),
  };

  useEffect(() => {
    async function initializeEditor() {
      const token = await getBeeToken(organizationId, true);
      beeEditor.current = new BeefreeSDK(token);
      await beeEditor.current.start(beeConfig, {});
    }
    initializeEditor();
  }, []);

  return <FullScreenContainer id="bee-plugin-file-manager" />;
};

export default BeeFileManager;
